<template>
<main :id="$route.name">
  <header class="receipts-header">
    <img :src="receipt.candidate.avatar" :alt="receipt.candidate.popular_name" class="receipt__avatar">
  </header>

  <article class="receipts" :aria-busy="receipt.lenght > 1 ? 'true' : 'false'">
    <div class="container">
      <div class="receipt-greetings">
        <h1>
            Recibo
        </h1>
        <p v-if="receipt.candidate.colective_name">
            Essa doação foi relizada para {{ receipt.candidate.colective_name }}, representado(a) por <strong>{{ receipt.candidate.popular_name }}</strong>,
            <template v-if="receipt.candidate.campaign_donation_type === 'campaign'">
              candidato(a)
            </template>
            <template v-else>
              pré-candidato(a)
            </template>
            a {{ receipt.candidate.office.name }}, pelo <abbr :title="receipt.candidate.party.name">{{ receipt.candidate.party.acronym }}</abbr>.
        </p>
        <p v-else>
          Essa doação foi realizada para <strong>{{ receipt.candidate.popular_name }}</strong>,
          <template v-if="receipt.candidate.campaign_donation_type === 'campaign'">
            candidato(a)
          </template>
          <template v-else>
            pré-candidato(a)
          </template>
          a {{ receipt.candidate.office.name }}, pelo <abbr :title="receipt.candidate.party.name">{{ receipt.candidate.party.acronym }}</abbr>.
        </p>
        <p>
          As doações eleitorais são muito importantes para construção de projetos políticos, porém é fundamental que as plataformas de financiamento coletivo, sociedade e o próprio TSE tenham garantias de que as informações ofereçam integridade e confiabilidade de maneira descentralizada para garantir controle social.
        </p>
        <p>
          Por isso, <strong>{{ receipt.candidate.popular_name }}</strong> está registrando todas suas doações financeiras para comprovar a integridade e honestidade no seu processo de captação de recursos.
        </p>
      </div>

      <div class="receipt-donation">
        <h2>Informações de doação</h2>
        <div class="receipt-donation__candidate">
          <ul>
            <li v-if="receipt.candidate.popular_name">
              <template v-if="receipt.candidate.campaign_donation_type === 'campaign'">
                candidato(a)
              </template>
              <template v-else>
                pré-candidato(a)
              </template>
              {{ receipt.candidate.popular_name }}
            </li>
            <li v-if="receipt.candidate.cnpj">CNPJ: {{ receipt.candidate.cnpj | formatCNPJ }}</li>
            <li v-if="receipt.candidate.cpf">CPF: {{ receipt.candidate.cpf | formatCPF }}</li>
            <li v-if="receipt.candidate.party.name">Partido: <abbr :title="receipt.candidate.party.name">{{ receipt.candidate.party.acronym }}</abbr></li>
            <li v-if="receipt.candidate.office.name">Cargo: {{ receipt.candidate.office.name }}</li>
          </ul>
        </div>
        <div class="receipt-donation__donator">
          <ul>
            <li v-if="receipt.is_irregular"><strong>Irregular / em análise:</strong> {{ receipt.irregular_reason }}</li>
            <li v-if="receipt.donor_name">Nome do doador: {{ receipt.donor_name | titleCase }}</li>
            <li v-if="receipt.name_receita">Nome na Receita Federal: {{ receipt.name_receita | titleCase }}</li>
            <li v-if="receipt.donor_cpf">CPF do doador: {{ receipt.donor_cpf | formatCPF }}</li>
            <li v-if="receipt.cpf_receita">CPF corrigido: {{ receipt.cpf_receita | formatCPF }}</li>
            <li v-if="receipt.captured_at_human">Data: {{ receipt.captured_at_human | date }}</li>
            <li v-if="receipt.amount">Valor: R${{ receipt.amount | formatBRL }}</li>
            <li v-if="receipt.payment_method_human">Forma de pagamento: {{ receipt.payment_method_human }}</li>
          </ul>
        </div>
      </div>
      <div class="receipt-donation__blockchain">
        <h2>Informações sobre o registro na blockchain</h2>
        <p>
          Para que sua doação tenha garantias, usamos o Blockchain, uma ferramenta que garantirá que todo histórico de doações ficará online e ninguém poderá alterá-lo, de maneira descentralizada.
        </p>
        <p>
          <strong>Comprovante decred:</strong>
          <a v-if="receipt.decred_transaction_url" :href="receipt.decred_transaction_url">{{ receipt.decred_transaction_url }}</a>
          <em v-else>em processamento</em>
        </p>
      </div>
      <div class="receipt-donation__got" v-if="receipt.git_url">
        <h2>Informações sobre o código utilizado para essa doação</h2>
        <p>
          Para transparência eleitoral, além dos dados de doação, também é fundamental que a tecnologia utilizado para processar essa doação seja aberto. Por isso, nosso código fonte é aberto e também registramos a versão utilizada por nossos servidores junto com os dados de doação na blockchain.
        <p>
          <strong>Versão do site:</strong>
          <a :href="receipt.git_url">{{ receipt.git_url }}</a>
        </p>
      </div>
      <div class="receipt-donation__got" v-if="receipt.git_url">
        <h2>Compartilhe</h2>
        <p>
          Faça parte desse movimento contra a corrupção eleitoral e fortaleça a nossa rede.
        <p>
          <ul class="wrap-share-buttons">
            <li>
              <a class="twitter" target="_blank" :href="'https://twitter.com/intent/tweet?hashtags=VotoLegal&twitter&text=Eu%20apoiei%20'+ receipt.candidate.popular_name +',%20apoie%20você%20também!%20https%3A%2F%2Fvotolegal.com.br%2Fem%2F'+ receipt.candidate.username +''"></a>
            </li>
            <li>
              <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fvotolegal.com.br%2Fem%2F'+ receipt.candidate.username +'&amp;src=sdkpreparse'" class="fb-xfbml-parse-ignore facebook"></a>
            </li>
          </ul>
        </p>
      </div>
    </div>
    <div class="receipt-footer">
      <div class="container">
        <div class="wrap-logos">
          <ul class="wrap-votolegal">
            <li>
              <a href="/" class="votolegal"></a>
            </li>
          </ul>
        </div>
        <p>
          <a href="https://votolegal.com.br" target="_blank">Voto Legal</a> é uma plataforma de software livre.
          Todas as doações são registradas na blockchain da Decred com objetivo de garantir a autenticidade das transações, promovendo a confiabilidade no processo de doação eleitoral.
        </p>
        <p>
          <strong>© 2016-2018 <a href="https://votolegal.com.br" target="_blank">Voto Legal</a> • Uma iniciativa <a href="http://appcivico.com" target="_blank">AppCívico</a> - Tecnologias Cívicas • <a :href="contract" target="_blank">Contrato</a></strong>
        </p>
      </div>
    </div>
  </article>
</main>
</template>

<script>
  import CONFIG from "./../../../config.js";

  export default {
    name: 'receipt',

    data() {
      return {
        contract: CONFIG.contract,
      };
    },

    mounted() {
      const payload = {
        candidateId: this.$route.params.candidate,
        digest: this.$route.params.digest
      };
      this.$store.dispatch('GET_RECEIPT', payload);
    },
    computed: {
      receipt() {
        return this.$store.state.receipt;
      },
    },
  };
</script>

<style src="../../../candidate-styles/index.scss" lang="scss"></style>



// WEBPACK FOOTER //
// _source/javascript/components/receipt/Receipt.vue